import { render, staticRenderFns } from "./upgrade_test.vue?vue&type=template&id=3d2291ec&scoped=true&"
import script from "./upgrade_test.vue?vue&type=script&lang=js&"
export * from "./upgrade_test.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_test.vue?vue&type=style&index=0&id=3d2291ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2291ec",
  null
  
)

export default component.exports